import React from 'react';
import LazyTable from 'app/component/lazy-table';
import { formatDateFromInstant } from 'app/shared/util/date-utils';
import { boldNameFormatter } from 'app/shared/util/formatters';
import { useAppSelector } from 'app/config/store';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';

const ContractNewTable: React.FC = () => {
  const isAdminOrAssistant = useAppSelector(state =>
    hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN, AUTHORITIES.ASSISTANT]),
  );

  return LazyTable({
    initialSortField: 'id',
    initialSortDirection: 'desc',
    createUrl: '/create-new-contract',
    labelForCreateEntity: 'Vytvoriť zmluvu',
    serverUrl: '/api/contracts/new',
    editActionAllowed: true,
    deleteActionAllowed: isAdminOrAssistant,
    globalFilterFields: ['policyHolder.firstName', 'policyHolder.lastName', 'product.insuranceCompany.name', 'product.name'],
    columns: [
      { field: 'id', header: 'ID', sortable: true },
      { field: 'createdDate', header: 'Vytvorené', sortable: true, formatter: formatDateFromInstant },
      {
        field: 'policyHolder.nameFullFormatted',
        header: 'Meno klienta',
        sortable: false,
        formatter: (_, v) => boldNameFormatter(v?.policyHolder?.nameFullFormatted),
      },
      { field: 'product.insuranceCompany.name', header: 'Spoločnosť', sortable: true },
      { field: 'product.name', header: 'Produkt', sortable: true },
    ],
  });
};

export default ContractNewTable;
